import { useParam } from "@blitzjs/next"
import { staffbar } from "pages/_app"
import { useEffect } from "react"

const StaffBarProvider = () => {
  const applicationId = useParam("applicationId", "number")
  const paywallId = useParam("paywallId", "number")
  const organizationId = useParam("organizationId", "number")

  useEffect(() => {
    if (applicationId && staffbar) {
      staffbar.registerContext("applicationId", applicationId)
    }
  }, [applicationId])

  useEffect(() => {
    if (paywallId && staffbar) {
      staffbar.registerContext("paywallId", paywallId)
    }
  }, [paywallId])

  useEffect(() => {
    if (organizationId && staffbar) {
      staffbar.registerContext("organizationId", organizationId)
    }
  }, [organizationId])

  return null
}

export default StaffBarProvider
